<template>
  <div>
    <v-dialog v-model="value" persistent max-width="900px" scrollable v-if="!isDialogPrintContrcts">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <div> {{ $t('contract.confirm_renew_contract') }} </div>
          <v-btn color="black" icon @click="onDismiss()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <RenewContractForm v-if="value" :contracts="contracts" :projectId="projectId" :marketId="marketId"
          @onSuccess="onSuccess" @onDismiss="onDismiss" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="isDialogPrintContrcts" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>{{ $t('contract.print_contract') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4">
          <p class="red--text">* {{ $t('validate.please_print_contract_every_time') }}</p>
          <ul>
            <li v-for="(template, index) in hashTemplate" :key="index">
              {{ template.title }}
              <v-btn class="mx-2" icon @click="printContract(template)"><v-icon>mdi-printer</v-icon></v-btn>
            </li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-checkbox v-model="isPrinted" :label="$t('validate.i_have_printed_the_contract')" />
          <v-spacer></v-spacer>
          <v-btn color="black" elevation="1" outlined large @click="isDialogPrintContrcts = false"
            :disabled="!isPrinted">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isDocumentEditorDialog" fullscreen class="editor-dialog" scrollable>
      <DocumentEditorDialog v-if="isDocumentEditorDialog && tempContractTemplate" type="preview"
        :title="tempContractTemplate.title" :layout="tempContractTemplate.layout"
        :paperSetting="tempContractTemplate.paperSetting" @onClose="isDocumentEditorDialog = false" />
    </v-dialog>
  </div>
</template>

<script>
import RenewContractForm from "@/components/RenewContractForm";
import DocumentEditorDialog from "@/components/DocumentEditorDialog.component.vue"
export default {
  props: {
    value: Boolean,
    contracts: Array,
    projectId: String,
    marketId: String,
  },
  components: {
    RenewContractForm,
    DocumentEditorDialog
  },
  data() {
    return {
      isDialogPrintContrcts: false,
      hashTemplate: null,
      isDocumentEditorDialog: false,
      tempContractTemplate: null,
      isPrinted: false
    }
  },
  methods: {
    onSuccess(data) {
      this.$emit("onSuccess", data)
      if (Object.keys(data.hashTemplate).length) {
        this.isPrinted = false
        this.hashTemplate = data.hashTemplate
        this.isDialogPrintContrcts = true
      }
    },
    printContract(template) {
      this.tempContractTemplate = template
      this.isDocumentEditorDialog = true
    },
    onDismiss() {
      this.$emit("input", false);
    }
  }
};
</script>